import { specialtyColor } from 'foundations-theming-specialty/utils';
// @ts-ignore - no TypeScript definitions available
import * as RespondentTypes from './respondentTypes';

export const RespondentTypeColorTokens: Record<string, string> = {
  [RespondentTypes.DETRACTOR]: specialtyColor(
    'reporting-fill-chart-default-light-pink'
  ),
  [RespondentTypes.PASSIVE]: specialtyColor(
    'reporting-fill-chart-default-light-orange'
  ),
  [RespondentTypes.PROMOTER]: specialtyColor(
    'reporting-fill-chart-default-light-green'
  ),
};

export const TRELLIS_SMILEYS_NEGATIVE_COLOR = '#FF7B70';
export const TRELLIS_SMILEYS_NEUTRAL_COLOR = '#EEB117';
export const TRELLIS_SMILEYS_POSITIVE_COLOR = '#6ACB8C';

export const TrellisSmileysRespondentColorTokens: Record<string, string> = {
  [RespondentTypes.DETRACTOR]: TRELLIS_SMILEYS_NEGATIVE_COLOR,
  [RespondentTypes.PASSIVE]: TRELLIS_SMILEYS_NEUTRAL_COLOR,
  [RespondentTypes.PROMOTER]: TRELLIS_SMILEYS_POSITIVE_COLOR,
};

export const resolveRespondentCssColor = (
  respondentType: string,
  useTrellisSmileys: boolean,
  theme: { color: Record<string, string> }
): string =>
  useTrellisSmileys
    ? TrellisSmileysRespondentColorTokens[respondentType]
    : theme.color[RespondentTypeColorTokens[respondentType]];
